module.exports = __webpack_public_path__ + "img/profile-background.d049971e.png";